/** @jsx jsx */
import * as React from "react";
import { css, jsx, InterpolationWithTheme } from "@emotion/core";


export interface IWarningInlineProps {
    errMsg: string;
};

const errorMsgStyles: InterpolationWithTheme<any> = {
    background: "#ffdcdc",
    borderRadius: "4px",
    color: "rgb(255, 0, 0)",
    fontFamily: "BrandonTextWeb-Medium",
    fontSize: "12px",
    fontWeight: 500,
    padding: "5px",
    display: "inline-block"
}

const iconStyles: InterpolationWithTheme<any> = {
    marginRight: "10px"
}
export const ErrorInline: React.FC<IWarningInlineProps> = (props: IWarningInlineProps) => {
    const { errMsg } = props;
    return <div css={errorMsgStyles}>
        <span className="glyphicon glyphicon-info-sign" aria-hidden="true" css={iconStyles}></span>
        {errMsg}</div>
}